import React, { Component } from 'react';
import "./css/style.css";

export default class CertTest extends Component {
    render() {
        return (
            <img src={"https://s3-ats-migration-test.s3.eu-west-3.amazonaws.com/test.jpg"} alt='' style={{
                maxWidth: '100%',
                maxHeight: '100%',
                bottom: '0',
                left: '0',
                margin: 'auto',
                overflow: 'auto',
                position: 'fixed',
                right: '0',
                top: '0',
                objectFit: 'contain' 
            }} />

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CertTest.js